import { Component, computed } from '@angular/core';
import { CustomWidget } from '../widget';
import { AbbChartComponent } from '@components/abb-chart/abb-chart.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'abb-column-chart-widget',
  standalone: true,
  imports: [AbbChartComponent, MatProgressSpinnerModule],
  template: `
    @if(loadingWidgetData()) {
    <mat-spinner class="mx-auto" [diameter]="50"></mat-spinner>
    } @else if (propertyName()) {
    <span class="text-abb-font/60 mb-1">
      {{ propertyName() }}
    </span>
    } @else if (groupName()) {
    <span class="text-abb-font/60 mb-1">{{ groupName() }}</span>
    } @if (!loadingWidgetData()) {
    <abb-chart
      class="block p-4"
      [chartType]="'bar'"
      [dataChart]="dataChart()"
      [yAxisLabel]="dataChart().label"
      [grow]="true"
      [useCustomLabels]="false"
      [xAxisType]="'category'"
    ></abb-chart>
    }
  `,
  styles: ``,
  host: {
    class: 'h-full w-full block',
  },
})
export class ColumnChartWidgetComponent extends CustomWidget {
  propertyName = computed(() => {
    return this.widget().propertyId
      ? this.properties().find((p) => p.id === this.widget().propertyId)?.name
      : '';
  });
  groupName = computed(() => {
    return this.widget().groupId
      ? this.groups().find((g) => g.id === this.widget().groupId)?.name
      : '';
  });
  dataChart = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'ChartData') {
      return data;
    }
    return { series: [], label: { text: '', unit: '' } };
  });
}
